/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Hero_DescriptionInputs */

const en_mcp_hero_description = /** @type {(inputs: Mcp_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect once, then ask your AI to send any text, doc or link to Listening. It turns into audio you can play on the go, 2 to 3x faster than reading.`)
};

const es_mcp_hero_description = /** @type {(inputs: Mcp_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctalo una vez y pide a tu IA que envíe cualquier texto, documento o enlace a Listening. Se convierte en audio que puedes escuchar donde quieras, de 2 a 3 veces más rápido que leyendo.`)
};

/**
* | output |
* | --- |
* | "Connect once, then ask your AI to send any text, doc or link to Listening. It turns into audio you can play on the go, 2 to 3x faster than reading." |
*
* @param {Mcp_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_hero_description = /** @type {((inputs?: Mcp_Hero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Hero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_hero_description(inputs)
	return en_mcp_hero_description(inputs)
});